import axios from 'axios';
import { ApiPath } from '../../api-path/ApiPath';

export default class ProfileService {

    async getUserProfile() {
        const response = await axios.get(`${ApiPath.baseUrl}/getUserProfile`, { timeout: 120000, timeoutErrorMessage: "request timeout" });
        if(response.status >= 400) {
            throw new Error(response.errors);
        }
        return response.data;
    }
}